import React from 'react';
import PropTypes from 'prop-types';

const AppHeader = ({ intro, instructions }: AppHeaderProps) => (
  <>
    {intro && (
      <>
        <p className="c-cyop__heading">{intro}</p>
        <br />
      </>
    )}

    {instructions && <p>{instructions}</p>}
  </>
);

AppHeader.defaultProps = {
  intro: '',
  instructions: '',
};

const appHeaderPropTypes = {
  intro: PropTypes.string,
  instructions: PropTypes.string,
};

AppHeader.propTypes = appHeaderPropTypes;

type AppHeaderProps = PropTypes.InferProps<typeof appHeaderPropTypes>;

export default AppHeader;
